import {
  Button,
  Edit,
  required,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextInput,
  Toolbar,
  useRedirect,
} from "react-admin";
import CancelIcon from "@mui/icons-material/Cancel";
import { brandChoises } from "../interfaces";

const EditCreateToolbar: React.FC = (props) => {
  const redirect = useRedirect();
  return (
    <Toolbar {...props}>
      <SaveButton />
      <Button
        variant="outlined"
        color="warning"
        label="Annuler"
        size="large"
        onClick={() => redirect("list", "clients")}
        sx={{ ml: 2, pl: 4 }}
      >
        <CancelIcon />
      </Button>
    </Toolbar>
  );
};

export const ClientEdit = () => (
  <Edit resource="clients">
    <SimpleForm toolbar={<EditCreateToolbar />}>
      <TextInput disabled source="id" />
      <TextInput
        source="internalCode"
        label="Code site interne"
        placeholder="Entrez le code interne du client"
        validate={[required("Le code interne est requis")]}
      />
      <TextInput
        source="name"
        label="Nom du client"
        placeholder="Entrez le nom du client"
        validate={[required("Le nom du client est requis")]}
      />
      <TextInput
        source="address"
        label="Adresse"
        placeholder="Entrez l'adresse du client"
        validate={[required("L'adresse est requise")]}
      />
      <TextInput
        source="zipCode"
        label="Code postal"
        placeholder="Entrez le Code postal du client"
        validate={[required("Code postal est requis")]}
      />
      <TextInput
        source="city"
        label="Ville"
        placeholder="Entrez le nom de la ville"
        validate={[required("Code postal est requis")]}
      />
      <TextInput
        source="siret"
        label="SIRET"
        placeholder="Entrez le SIRET du client"
        validate={[required("SIRET est requise")]}
      />
      <SelectInput
        source="brand"
        label="Marque"
        validate={[required("La marque est requise")]}
        choices={brandChoises}
      />
      <TextInput
        source="contactName"
        label="Interlocuteur exploitation"
        placeholder="Entrez le nom de l'interlocuteur"
      />
      <TextInput
        source="email"
        label="Email"
        placeholder="Entrez l'email du client"
        validate={[required("L'email est requis")]}
      />
      <TextInput
        source="phone"
        label="Tél exploitation"
        placeholder="Entrez le numero de tél de l'exploitation"
        validate={[required("Tél est requis")]}
      />
    </SimpleForm>
  </Edit>
);
